import { observer } from '@formily/reactive-vue';
import { connect, mapProps, mapReadPretty, h, useField } from '@formily/vue';
import { defineComponent, ref, watch } from '@vue/composition-api';
import { Uploader as VanUploader, Toast } from 'vant';
import { PreviewText } from '@formily/vant';
import 'vant/lib/uploader/index.less';
import '@formily/vant/esm/preview-text/style';
import request from 'axios';
import store from '@/store';
import NewUpload from './newUpload.vue';
import { previewFileInPopup } from './filePreviewPopup';


// const TransformVanUploader = transformComponent(VanUploader, {
//   change: 'input',
// });

const BaseUploader = observer(
  defineComponent({
    name: 'FBaseUploader',
    props: ['value'],
    setup(props, { attrs, slots, listeners, emit }) {
      const field = useField();
      field.value.decoratorType = field.value.title ? 'FormItem' : null;
      const valueList = ref([]);
      const filePathList = ref([]);
      watch(
        () => props.value,
        () => {
          filePathList.value = props.value || [];
          valueList.value = props.value ? props.value.map((item) => item.response.FileList[0]) : [];
        },
        { deep: true, immediate: true }
      );

      const afterRead = async (file) => {
        const userId = sessionStorage.getItem('userid');
        const fileList = file.length ? [...file] : [file];

        const isOpenUpload = store.getters.getConfigItem('isOpenUpload');
        console.log(isOpenUpload,"isOpenUpload");
        
        if (isOpenUpload === '1') {
          // 显示全局loading
          Toast.loading({
            message: '上传中，请勿离开页面',
            forbidClick: true,
            duration: 0
          });
        }

        for (file of fileList) {
          valueList.value.push({ status: 'uploading', message: '上传中...' });
          try {
            const reqData = new FormData();
            reqData.append(field.value.componentProps?.name || 'file', file.file);
            if (field.value.componentProps?.data) {
              Object.entries(field.value.componentProps?.data).forEach(([key, value]) => {
                reqData.append(key, value);
              });
            }
            const { data } = await request.post(field.value.componentProps?.action || `/relay/cosfile/index`, reqData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                ...(field.value.componentProps?.headers || {}),
                authToken: sessionStorage.getItem('AuthToken'),
                userid: sessionStorage.getItem('userid'),
              },
            });
            if (!data?.FileList?.length) {
              throw new Error();
            } else {
              filePathList.value.push(
                ...data?.FileList?.map((item) => ({
                  name: file.file.name,
                  response: {
                    FileList: [{ ...item, name: file.file.name }],
                  },
                }))
              );
              valueList.value.splice(-1, 1, ...data?.FileList?.map(({ url }) => ({ url })));
            }
          } catch (e) {
            Toast.fail('上传失败，请稍后再试');
            valueList.value.pop();
          } finally {
            // 结束全局loading
            Toast.clear();
          }
        }
        // field.value.setValue(filePathList.value);
        emit('change', filePathList.value);
        console.log(valueList);
      };

      const beforeDelete = ({ url }) => {
        const index = valueList.value.findIndex((item) => item.url === url);
        valueList.value.splice(index, 1);
        filePathList.value.splice(index, 1);
        // field.value.setValue(filePathList.value);
        emit('change', filePathList.value);
      };

      const oversize = () => {
        const maxFileSize = Number(attrs.maxFileSize) || 0;
        return Toast.fail(
          maxFileSize > 0
            ? `上传文件大小不能超过${maxFileSize}MB`
            : '上传文件大小不能超过300M'
        );
      };

      return () =>
        h(
          NewUpload,
          {
            attrs: {
              accept: '*',
              ...attrs,
              maxCount: attrs.maxCount ?? undefined,
              fileList: valueList.value,
              // 文件大小上限（字节），未配置时沿用默认的 300MB
              maxSize: attrs.maxFileSize > 0 ? attrs.maxFileSize * 1024 * 1024 : 300000 * 1024,
              // 设计器配置的上限（MB），供微信/企微选图链路单独校验（该链路不经过 Vant beforeRead）
              maxFileSize: Number(attrs.maxFileSize) || 0,
              afterRead,
              beforeDelete,
              'result-type': 'file',
              // 支持字段禁用状态
              disabled: field.value.disabled || false,
              // 透传外部通过 $props 响应器注入的自定义校验函数
              // 兼容两种写法：不带 @（进 attrs，prop 写法）和带 @（进 listeners，事件写法）
              // ===== 调试日志 =====
              beforeReadProp: (() => {
                const fn = attrs['before-read'] || attrs.beforeReadProp || listeners['before-read'] || null;
                return fn;
              })(),
              beforeUploadProp: (() => {
                const fn = attrs['before-upload'] || attrs.beforeUploadProp || listeners['before-upload'] || null;
                return fn;
              })(),
            },
            on: {
              ...listeners,
              oversize,
              'click-preview': (file, detail) => {
                const fileType = file?.url?.split?.('.');
                console.log(file, detail, fileType);
                if (
                  Array.isArray(fileType) &&
                  !['jpg', 'jpeg', 'png', 'svg', 'bmp'].some((item) =>
                    fileType?.[fileType.length - 1].endsWith(item)
                  )
                ) {
                  // 优先使用企微原生 previewFile（支持所有文件类型）
                  const isWxEnv = typeof window !== 'undefined' &&
                    (window.navigator.userAgent.toLowerCase().includes('micromessenger') ||
                     window.navigator.userAgent.toLowerCase().includes('wxwork'));
                  if (isWxEnv && typeof wx !== 'undefined' && wx.config) {
                    const wxApi = typeof ww !== 'undefined' ? ww : wx;
                    fetch(file.url, { method: 'HEAD' }).then(resp => {
                      const size = parseInt(resp.headers.get('content-length') || '0', 10);
                      wxApi.ready(() => {
                        wxApi.invoke('previewFile', {
                          url: file.url,
                          name: file.name || '',
                          size: size,
                        }, (res) => {
                          if (!res || !res.err_msg || res.err_msg.indexOf('ok') < 0) {
                            previewFileInPopup(file.url, file.name || '');
                          }
                        });
                      });
                    }).catch(() => {
                      previewFileInPopup(file.url, file.name || '');
                    });
                  } else {
                    // 非企微环境：弹窗预览
                    previewFileInPopup(file.url, file.name || '');
                  }
                }
              },
              click(e) {
                emit('emit', e);
              },
            },
          },
          slots
        );
    },
  })
);

export const Uploader = connect(
  BaseUploader,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(PreviewText.Uploader)
);

export default Uploader;
